import { Link, useNavigate } from 'react-router-dom';
import './Collection.css';
import ProfileGoBackButton from '../ProfileGoBackButton/ProfileGoBackButton';
import { PROFILE_COLLECTION_ADD_LINK, PROFILE_MAIN_LINK } from '../../../assets/utils/constants';
import { useEffect, useState } from 'react';
import mainAppApi from '../../../assets/api/MainAppApi';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import moment from 'moment/moment';
import CollectionCard from './СollectionCard/СollectionCard'
import { parsePrice } from '../../../assets/utils/utils';
const LIMIT = 25
function formatPercent(value) {
    const rounded = Number(value.toFixed(1));
    if (Number.isInteger(rounded)) {
        return rounded.toString();
    }
    return rounded.toString();
}


function Collection() {
    const navigate = useNavigate()


    const [data, setData] = useState(null)
    const [mainStats, setMainStats] = useState(null)
    const [preloaders, setPreloaders] = useState({
        getData: true,
        getMainStats: true,
    })

    useEffect(() => {
        mainAppApi.getCollectionItems({
            limit: LIMIT,
        })
            .then((res) => {
                console.log(res)
                setData(res)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    getData: false,
                }))
                const start = moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DDT00:00:00');
                const end = moment().startOf('day').format('YYYY-MM-DDT00:00:00');
                mainAppApi.getCollectionMainStats({
                    start,
                    end,
                })
                    .then((res) => {
                        console.log(res)
                        function getPercentChange(current, previous) {
                            if (previous === 0 && current === 0) return 0;
                            if (previous === 0) return 100; // from 0 to something = +100%
                            return ((current - previous) / Math.abs(previous)) * 100;
                        }
                        setMainStats({
                            ...res,
                            percentChange: getPercentChange(res.current, res.previous),
                        })
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                    .finally(() => {
                        setPreloaders(prevValue => ({
                            ...prevValue,
                            getMainStats: false,
                        }))
                    })
            })
    }, [])

    return (
        <div className='collection'>
            <div className='collection__heading'>
                <ProfileGoBackButton
                    onClick={() => {
                        navigate(`/${PROFILE_MAIN_LINK}`)
                    }}
                />
                <div className='collection__heading-title-box' >
                    <p className='collection__heading-title'>Collection</p>
                </div>
            </div>
            <div className='collection__total'>
                <div className='collection__total-box'>
                    <p className='collection__total-title'>Total price</p>
                    {preloaders.getMainStats ?
                        <div className='collection__total-preloader'>
                            <MiniPreloader />
                        </div>
                        :
                        mainStats ?
                            <div className='collection__total-values'>
                                <p className='collection__total-value-price'>{parsePrice(Number(mainStats.current), 'USD')}</p>
                                <p className={`collection__total-value-change ${mainStats.percentChange > 0 ? 'collection__total-value-change_plus' : mainStats.percentChange < 0 ? 'collection__total-value-change_minus' : 'collection__total-value-change_equal'}`}>
                                    {mainStats.percentChange > 0 && '↑'}{mainStats.percentChange < 0 && '↓'}{formatPercent(mainStats.percentChange)}%
                                </p>
                            </div>
                            : null
                    }
                </div>
                <Link to={`${PROFILE_COLLECTION_ADD_LINK}`} className='collection__total-add'>
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1762_11394)">
                            <path d="M3.20118 8V0H4.7929V8H3.20118ZM0 4.7929V3.20118H8V4.7929H0Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_1762_11394">
                                <rect width="8" height="8" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </Link>
            </div>
            {preloaders.getData ?
                <div className='collection__preloader'>
                    <MiniPreloader />
                </div>
                :
                data && data.data.length > 0 ?
                    <div className='collection__list'>
                        {data.data.map((item, i) => (
                            <CollectionCard item={item} key={`collection__list-item${item._id}`}>

                            </CollectionCard>
                        ))}
                    </div>
                    :
                    <p className='collection__no-item'>No Items in Collection Yet</p>
            }
        </div>
    );
}

export default Collection